import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { TuiButton, TuiDropdown } from '@taiga-ui/core';
import { TuiButtonSelect, TuiChevron, TuiDataListWrapper } from '@taiga-ui/kit';
import { ClientData } from 'src/app/shared/models/base/client-data';
import { Size } from 'src/app/shared/models/enums/size.enum';
import { ClientImageComponent } from '../../shared/client-image/client-image.component';
import { AnimateFadeDirective } from '../../shared/directives/animate-fade.directive';

@Component({
  selector: 'pxc-client-picker',
  templateUrl: './client-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AnimateFadeDirective,
    ClientImageComponent,
    FormsModule,
    NgTemplateOutlet,
    TranslocoDirective,
    TuiButton,
    TuiButtonSelect,
    TuiChevron,
    TuiDataListWrapper,
    TuiDropdown,
  ],
})
export class ClientPickerComponent implements OnChanges {
  @Input() clients: { [clientCode: string]: ClientData };
  @Input() selectedClient: string;
  @Input() collapsed = false;
  @Input() size = Size.MEDIUM;
  @Input() disabled = false;

  @Output() selectedClientChange = new EventEmitter<string>();

  clientCodes: string[] = [];
  Size = Size;

  ngOnChanges({ clients }: SimpleChanges): void {
    if (!clients) {
      return;
    }

    const clientKeysCurrent = Object.keys(clients.currentValue);
    const clientKeysPrevious = Object.keys(clients.previousValue || {});

    const keysHaveChanged =
      clientKeysCurrent.length !== clientKeysPrevious.length ||
      clientKeysCurrent.some((key) => !clientKeysPrevious.includes(key));

    if (keysHaveChanged) {
      this.clientCodes = clientKeysCurrent;
    }
  }

  selectClient(clientCode: string): void {
    this.selectedClientChange.emit(clientCode);
  }
}
